import LoadMore from './LoadMore'

export default LoadMore
// eslint-disable-next-line import/export
export * from './LoadMore'
